/**
 * Check-In Analytics slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';

export interface CheckInAnalytics {
  todayAverageMood: number | null;
  todayAverageMoodName: string | null;
  totalTodayCheckIns: number;
}

const initialState = {
  checkInAnalytics: null as CheckInAnalytics | null,
  loading: false,
  error: null as string | null,
};

const checkInAnalyticsSlice = createSlice({
  name: 'checkInAnalytics',
  initialState,
  reducers: {
    setCheckInAnalytics(state, action) {
      state.checkInAnalytics = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const checkInAnalyticsReducer = checkInAnalyticsSlice.reducer;

// Actions
export const {
  setCheckInAnalytics,
  setLoading,
  setError,
  clearError,
} = checkInAnalyticsSlice.actions;

// Async Actions
export const fetchCheckInAnalytics = createAction('CHECKIN_ANALYTICS/FETCH_ANALYTICS');

